export default {
  'pdfTemplateGenerationMapping.title': 'Document Generation Mappings',

  'pdfTemplateGenerationMapping.form.templateGenerationFormat': 'Format to Generate',
  'pdfTemplateGenerationMapping.form.pdfTemplate': 'Template',
  'pdfTemplateGenerationMapping.form.documentNamePattern': 'Document Name Pattern',
  'pdfTemplateGenerationMapping.form.select.PDF': 'PDF Format',
  'pdfTemplateGenerationMapping.form.select.Word': 'Word Format',
  'pdfTemplateGenerationMapping.form.externalViewEnabled': 'Enable External View',
  'pdfTemplateGenerationMapping.form.destinationFolder': 'Destination Folder',

  'pdfTemplateGenerationMapping.mapping': 'Mapping',
  'pdfTemplateGenerationMapping.addMapping': 'Add mapping',
  'pdfTemplateGenerationMapping.noMappings': 'No mappings configured.',
};
